import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import {StickyTable, Row, Cell} from 'react-sticky-table';
import Tooltip from '@material-ui/core/Tooltip';
import {TableRow, TableCell, Table, TableHead, TableBody, Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { compose } from 'underscore';
import { api_host, api_auth } from '../../../../../common/globals/constants';
import icons from '../../../../../theme/icons.js';
import { lista_estados } from '../../../../../data/status_error_icons.js';
import { withTranslation } from 'react-i18next';
import WarningIcon from '@material-ui/icons/Warning';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { reportFetchError } from '../../../../../observability/rum';
class ObjectiveCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            objective: this.props.objectivesList,
            nodesIdList: this.props.nodesIdList,
            nodesMonitorsIdList: this.props.nodesMonitorsIdList,
            isLoading: true,
            loadError: false,
            apiData: null,
        }
    }

    componentDidMount() {
        this.getDataFromAPI();
    } 

    componentDidUpdate(prevProps) {
        if (prevProps.showPatronesInversos !== this.props.showPatronesInversos && this.state.apiData) {
            this.processData(this.state.apiData);
        }
    }

    getDataFromAPI = () => {
        const {objective} = this.state
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')        
        Promise.all([
            fetch(api_host+`/reporte/online/indicadores/getLastStatusObjectiveByNode/?user=${user}&objetivoId=${objective.objetivo_id}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&timestamp=${new Date().getTime()}`)
        ])
        .then(([res1]) => {
            return Promise.all([res1.json()])
        })
        .then(([res1]) => {
            this.processData(res1);
            this.setState({apiData: res1});
        })
        .catch((error) => {
            reportFetchError('QuickViewIspFullObjectiveCell', error)
            const emptyData = {nodos: []}
            this.processData(emptyData);
            this.setState({apiData: emptyData, loadError: true});
        })
        
    }

    processData = (res1) => {
        const {objective, nodesIdList, nodesMonitorsIdList} = this.state
        var stepsPatterns = objective.Pasos_patrones
        let codesOk = [0,9,14,17,30,200,204,301,304,307,602,1000]
        
        let cellObjective = []
        let cellStepFinal = []
        let cell = []
        Object(stepsPatterns).map((step, ordenStep)=>{
            let cellStep = []
            var cellDataStepFinal = {}
            var isReverse = false
            const patronesPaso = step.patrones.filter(item => {
                if (item.es_inverso){
                    if (item.es_inverso !== 'f'){
                        isReverse = true
                    }
                }
                if (item.tipo === "inverso"){
                    if (item.es_inverso !== 'f'){
                        isReverse = true
                    }
                }
                if (!this.props.showPatronesInversos) {
                    if (item.es_inverso){
                        return item.es_inverso === 'f'
                    }
                    if (item.tipo === "inverso"){
                        return item.es_inverso === 'f'
                    }
                    return true;
                } 
                return true;
            })
            
            if (patronesPaso.length > 0){
                Object(patronesPaso).map((pattern, ordenPattern)=>{
                    let cellStep = []
                    var cellDataStepFinal = {}
                    Object(nodesIdList).map((node, ordenNodeIdList)=>{
                        var ok = false
                        var cellDataStep = {}
                        Object(res1.nodos).map((nodeStatus, orden)=>{
                            if (node == nodeStatus.nodo_id && !ok){
                                if (nodeStatus.duracion >= 86400){
                                    var newDate = new Date(parseInt(nodeStatus.duracion) * 1000)
                                    var day = parseInt(newDate.getDate())
                                    cellDataStep['duration'] = day + ' día(s) ' + new Date(parseInt(nodeStatus.duracion) * 1000).toISOString().substr(11, 8)
                                }else{
                                    cellDataStep['duration'] = new Date(parseInt(nodeStatus.duracion) * 1000).toISOString().substr(11, 8)
                                }
                                var icon = <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO, zoom: "normal", scale: "0.1", transform: "none"}}/>
                                if (nodeStatus.status != 'no_monitoreo') {
                                    Object(nodeStatus.pasos).map((nodeStep, ordenStep)=>{
                                        if (parseInt(step.id_paso) == nodeStep.id_paso && !ok){
                                            var isMonitorInPattern = false
                                            const patrones = nodeStep.patrones.filter(item => {
                                                if (!this.props.showPatronesInversos) {
                                                    return item.tipo !== 'inverso'    
                                                }
                                                return true;
                                            })
                                            Object(nodesMonitorsIdList[ordenNodeIdList]).map((nodeMonitor, orden)=>{
                                                patrones.map((stepPattern, orden)=>{
                                                    if(stepPattern.monitor_id && parseInt(stepPattern.monitor_id) == parseInt(nodeMonitor.monitor)){
                                                        isMonitorInPattern = true
                                                    }
                                                })
                                            })
                                            var codeDescription = nodeStep.codigo_descripcion[0]
                                            if (nodeStep.codigo_descripcion.length > 0){
                                                codeDescription = nodeStep.codigo_descripcion[parseInt(pattern['orden'])]
                                            }
                                            /* validacion si es que existe codeDescription */
                                            try {
                                                let tryD = codeDescription['codigo_id']
                                            }
                                            catch{
                                                codeDescription = nodeStep.codigo_descripcion[0]
                                            }
                                                
                                            /*if (codeDescription.length > 0) {
                                                if (parseInt(pattern.orden) >= codeDescription.length){
                                                    var index = codeDescription.length - 1
                                                    codeDescription = nodeStep.codigo_descripcion[index][0]
                                                } else {
                                                    codeDescription = nodeStep.codigo_descripcion[parseInt(pattern.orden)][0]
                                                }
                                            }*/
                                            if (codesOk.includes(parseInt(codeDescription['codigo_id']))){
                                                icon = <i style={{...icons.sprite, ...icons.spriteOK, zoom: "normal", scale: "0.1", transform: "none"}}/>
                                            } else if (codeDescription['codigo_id'] in lista_estados){
                                                var icon = lista_estados[codeDescription['codigo_id']].icono
                                                icon = <i style={{...icons.sprite, ...icons[icon], zoom: "normal", scale: "0.1", transform: "none"}}/>
                                            } else {
                                                icon = <i style={{...icons.sprite, ...icons.spriteSIN_NOMBRE, zoom: "normal", scale: "0.1", transform: "none"}}/>
                                            }
                                            cellDataStep['status'] = nodeStep.estado
                                            cellDataStep['descripcion'] = codeDescription['descripcion']
                                            cellDataStep['nombre_estado'] = codeDescription['nombre']
                                            cellDataStep['respuesta'] = nodeStep.respuesta_segundos == "-1000" ? "s/i" : nodeStep.respuesta_segundos + " [s]"
                                            cellDataStep['icon'] = icon
                                            cellDataStep['nombre_paso_tooltip'] = nodeStep.nombre_paso
                                            cellDataStep['nodo_id'] = nodeStatus.nodo_id
                                            cellDataStep['isMonitorInPattern'] = isMonitorInPattern
                                            cellDataStep['pattern'] = ""
                                            if (pattern.monitor_id) {
                                                if(isMonitorInPattern){
                                                    if(parseInt(nodeStatus.monitor_id) != parseInt(pattern.monitor_id)){
                                                        cellDataStep['monitor_id'] = nodeStatus.monitor_id
                                                        cellDataStep['nodo_id_validacion'] = nodeStatus.nodo_id
                                                    } else {
                                                        cellDataStep['monitor_id'] = nodeStatus.monitor_id
                                                        cellDataStep['nodo_id_validacion'] = ""
                                                        cellDataStep['pattern'] = pattern.nombre ? pattern.nombre : ""
                                                    }
                                                } else {
                                                    cellDataStep['monitor_id'] = ""
                                                    cellDataStep['nodo_id_validacion'] = nodeStatus.nodo_id
                                                }
                                                
                                            } else {
                                                cellDataStep['monitor_id'] = ""
                                                cellDataStep['nodo_id_validacion'] = ""
                                                cellDataStep['pattern'] = pattern.nombre ? pattern.nombre : ""
                                            }
                                            cellStep.push(cellDataStep)
                                            ok = true
                                        }
                                    })
                                }else{
                                    cellDataStep['status'] = 'no_monitoreo'
                                    cellDataStep['respuesta'] = '0,00 [s]'
                                    cellDataStep['descripcion'] = 'El objetivo no fue monitoreado durante este periodo'
                                    cellDataStep['nombre_estado'] = 'Periodo sin monitoreo'
                                    cellDataStep['pattern'] = pattern.nombre ? pattern.nombre : ""
                                    cellDataStep['icon'] = icon
                                    cellDataStep['nodo_id'] = nodeStatus.nodo_id
                                    cellStep.push(cellDataStep)
                                    ok = true
                                }
                            }
                        })
                        if (!ok){
                            cellDataStep['status'] = ""
                            cellDataStep['icon'] = ""
                            cellDataStep['respuesta'] = ""
                            cellStep.push(cellDataStep)
                        }
                    })
                    cellDataStepFinal['step'] = ordenPattern == 0 ? step.nombre_paso : ""
                    cellDataStepFinal['step_id'] = step.id_paso
                    cellDataStepFinal['data'] = cellStep
                    cellDataStepFinal['reverse'] = isReverse
                    cellStepFinal.push(cellDataStepFinal)
                })
            } else {
                Object(nodesIdList).map((node, orden)=>{
                    var ok = false
                    var cellDataStep = {}
                    Object(res1.nodos).map((nodeStatus, orden)=>{
                        if (node == nodeStatus.nodo_id && !ok){
                            if (nodeStatus.duracion >= 86400){
                                var newDate = new Date(parseInt(nodeStatus.duracion) * 1000)
                                var day = parseInt(newDate.getDate())
                                cellDataStep['duration'] = day + ' día(s) ' + new Date(parseInt(nodeStatus.duracion) * 1000).toISOString().substr(11, 8)
                            }else{
                                cellDataStep['duration'] = new Date(parseInt(nodeStatus.duracion) * 1000).toISOString().substr(11, 8)
                            }
                            var icon = <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO, zoom: "normal", scale: "0.1", transform: "none"}}/>
                            if (nodeStatus.status != 'no_monitoreo') {
                                Object(nodeStatus.pasos).map((nodeStep, ordenStep)=>{
                                    if (parseInt(step.id_paso) == nodeStep.id_paso && !ok){
                                        var codeDescription = nodeStep.codigo_descripcion[0]
                                        if (codesOk.includes(parseInt(codeDescription['codigo_id']))){
                                            icon = <i style={{...icons.sprite, ...icons.spriteOK, zoom: "normal", scale: "0.1", transform: "none"}}/>
                                        } else if (codeDescription['codigo_id'] in lista_estados){
                                            var icon = lista_estados[codeDescription['codigo_id']].icono
                                            icon = <i style={{...icons.sprite, ...icons[icon], zoom: "normal", scale: "0.1", transform: "none"}}/>
                                        } else {
                                            icon = <i style={{...icons.sprite, ...icons.spriteSIN_NOMBRE, zoom: "normal", scale: "0.1", transform: "none"}}/>
                                        }

                                        cellDataStep['status'] = nodeStep.estado
                                        cellDataStep['descripcion'] = nodeStep.codigo_descripcion[0]['descripcion']
                                        cellDataStep['nombre_estado'] = nodeStep.codigo_descripcion[0]['nombre']
                                        cellDataStep['respuesta'] = nodeStep.respuesta_segundos == "-1000" ? "s/i" : nodeStep.respuesta_segundos + " [s]"
                                        cellDataStep['icon'] = icon
                                        cellDataStep['nombre_paso_tooltip'] = nodeStep.nombre_paso
                                        cellDataStep['nodo_id'] = nodeStatus.nodo_id
                                        cellDataStep['pattern'] = ""
                                        cellStep.push(cellDataStep)
                                        ok = true
                                    }
                                })
                            }else{
                                cellDataStep['status'] = 'no_monitoreo'
                                cellDataStep['respuesta'] = '0,00 [s]'
                                cellDataStep['descripcion'] = 'El objetivo no fue monitoreado durante este periodo'
                                cellDataStep['nombre_estado'] = 'Periodo sin monitoreo'
                                cellDataStep['icon'] = icon
                                cellDataStep['nodo_id'] = nodeStatus.nodo_id
                                cellDataStep['pattern'] = ""
                                cellStep.push(cellDataStep)
                                ok = true
                            }
                        }
                    })
                    if (!ok){
                        cellDataStep['status'] = ""
                        cellDataStep['code'] = ""
                        cellDataStep['icon'] = ""
                        cellStep.push(cellDataStep)
                    }
                })
                cellDataStepFinal['step'] = step.nombre_paso
                cellDataStepFinal['step_id'] = step.id_paso
                cellDataStepFinal['data'] = cellStep
                cellDataStepFinal['reverse'] = isReverse
                cellStepFinal.push(cellDataStepFinal)
            }
        })
        Object(nodesIdList).map((node, orden)=>{
            var ok = false
            var cellData = {}
            var cellDataObjective = {}
            var cellDataStep = {}
            Object(res1.nodos).map((nodeStatus, orden)=>{
                if (node == nodeStatus.nodo_id && !ok){
                    cellDataObjective['hour'] = nodeStatus.fecha_tz.substr(11, 8)
                    cellDataObjective['date'] = nodeStatus.fecha_tz.substr(0, 10)
                    cellObjective.push(cellDataObjective)
                    ok = true
                } 
            })
            Object(cellStepFinal).map((cell, ordenCell)=>{
                Object(cell.data).map((cellData, ordenCellData)=>{
                    if(cellData.nodo_id_validacion){
                        if(cellData.nodo_id_validacion == node){
                            cellData.icon = ""
                            cellData.respuesta = ""
                        }
                    }
                })
            })
            if (!ok){
                cellData['status'] = ""
                cellData['code'] = ""
                cellData['duration'] = ""
                cellData['color'] = ""
                cellData['icon'] = ""
                cellData['step'] = ""
                cellDataObjective['date'] = ""
                cellDataObjective['hour'] = ""
                cell.push(cellData)
                cellObjective.push(cellDataObjective)
            }
        })
        this.setState({cells: cell, isLoading: false, cellObjective: cellObjective, cellStepFinal: cellStepFinal});
    }

    handleClose = event => {

        /*if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })*/
        this.props.onClose()
    };
    
    render() {
        const {isLoading, loadError, cells, objective, cellObjective, cellStepFinal, nodesIdList} = this.state
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (!isLoading)  {
            return  <>
                        <Row>
                            <Cell style={{maxWidth:'360px', minWidth:'360px', backgroundColor: objective.color_custom, color:'white', 
                            borderRight: "2px solid #e4dede", left: 0, position: "sticky", zIndex: 2}}>
                                <Tooltip title={<div>
                                            <Typography variant="h5" style={{color:'white'}}>{objective.nombre}</Typography>
                                            </div>}>
                                    <Button id={objective.objetivo_id} value={objective.nombre} onClick={this.props.handleOpenObjectiveModal}>
                                        <Typography variant="h6" style={{color:'white'}}>{objective.nombre.substr(0,30)}</Typography>
                                    </Button>
                                </Tooltip>
                                {loadError ?
                                    <Typography variant="caption" style={{color:'white', display:'block', paddingLeft:'8px'}}>{t('text.load-error')}</Typography>
                                : null}
                            </Cell>
                            {Object(cellObjective).map(cell=>(
                                <Cell style={{maxWidth:'130px', minWidth:'130px', borderRight: "2px solid #e4dede", color:'white' , backgroundColor: objective.color_custom}}>
                                    <Typography style={{fontWeight:'bold', color:'white'}}>{cell.hour}</Typography>
                                    <Typography style={{fontWeight:'bold', color:'white'}}>{cell.date}</Typography>
                                </Cell>
                            ))}
                        </Row>
                        {Object(cellStepFinal).map((cell,key)=>(
                            <Row>
                                {cell.step != '' ?
                                        <Cell style={{padding: '0px', maxWidth:'250px', minWidth:'250px', 
                                                        height:'80px',textAlign:'right', 
                                                        paddingRight:'10px', backgroundColor: '#d4d4d4', 
                                                        left: 0, position: "sticky", zIndex: 2,
                                                        color:'white', borderBottom: "2px solid #e4dede", borderTop: key != 0 ? "2px solid #818181": null}}>
                                            <Box
                                                sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'flex-end',
                                                height: '100%',
                                                paddingRight: '10px',
                                                gap: 5, // Espaciado de 8px entre el loader y el texto
                                                }}
                                            >
                                                <Typography variant="h5" style={{color:'black'}}>
                                                    {cell.step?.slice(0, 50)}
                                                </Typography>
                                                {cell.reverse?
                                                    <Tooltip title={t('quickview-isp.cell.popover.text.reverse')} arrow placement="top">
                                                        <span>
                                                            <WarningAmberIcon 
                                                                color="warning" 
                                                                sx={{
                                                                    animation: 'pulse 1.5s infinite ease-in-out',
                                                                    '@keyframes pulse': {
                                                                      '0%, 100%': { transform: 'scale(1)' },
                                                                      '50%': { transform: 'scale(1.2)' },
                                                                    },
                                                                }}
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                : null}
                                            </Box>
                                        </Cell> 
                                :<Cell style={{padding: '0px', maxWidth:'250px', minWidth:'250px', 
                                                height:'80px', paddingLeft:'60px', backgroundColor: '#d4d4d4', left: 0, position: "sticky", zIndex: 2, 
                                                color:'white', borderBottom: "2px solid #e4dede", borderRight: "2px solid #e4dede"}}>
                                    <Typography variant="h5" style={{color:'white'}}></Typography>
                                </Cell>}
                                {Object(cell.data).map(cellData=>(
                                    cellData.icon != "" ? 
                                    <Tooltip 
                                        title={<div>
                                            <Typography variant="h5" style={{color:'white'}}>{cellData.nombre_estado}</Typography>
                                            <Typography variant="h6" style={{color:'white'}}>{cellData.descripcion}</Typography>
                                            <Typography variant="h6" style={{color:'white'}}>{t('quickview-isp.popover.text.response')+": "+cellData.respuesta}</Typography>
                                            <Typography variant="h6" style={{color:'white'}}>{t('quickview-isp.popover.text.duration')+": "+cellData.duration}</Typography>
                                            <Typography variant="h6" style={{color:'white'}}>{t('quickview-isp.popover.text.step')+": "+cellData.nombre_paso_tooltip}</Typography>
                                            {cellData.pattern ? <Typography variant="h6" style={{color:'white'}}>{t('quickview-isp.popover.text.pattern')+": "+cellData.pattern}</Typography> : null}
                                            </div>} 
                                        placement="bottom" arrow>
                                            <Cell style={{padding: '0px', maxWidth:'130px', height:'80px', 
                                                                borderBottom: "2px solid #d4d4d4", borderRight: "2px solid #e4dede", 
                                                                backgroundColor: '#e9e9e9', borderTop: cell.step != '' && key != 0 ? "2px solid #818181" : null}}>
                                                 <Box 
                                                    // Set this Box as a Flex container to manage its children
                                                    style={{
                                                        height: '100%', // Assume it fills the height of the parent cell
                                                        
                                                        // 🚨 IMPORTANT: Use Flexbox to stack and center the icon and text
                                                        flexDirection: 'column', // Stack vertically
                                                        justifyContent: 'center', // Center group vertically
                                                        alignItems: 'center',   // Center group horizontally
                                                    }}
                                                >
                                                    {/* 1. Icon Container */}
                                                    <div style={{
                                                        paddingTop:'15px',
                                                        // Maintain the icon's container height and let Flexbox handle centering
                                                        height: "30px", 
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        paddingLeft: nodesIdList.length <= 6 ? "48%" : "45%"
                                                    }}>
                                                        {cellData.icon}
                                                    </div>

                                                    {/* 2. Answer Text */}
                                                    <Typography 
                                                        variant="body2" 
                                                        style={{
                                                            fontWeight: 'bold', 
                                                            textAlign: 'center',
                                                            // Set horizontal padding for spacing, not centering
                                                            paddingTop:'20px',
                                                            paddingLeft: cellData.respuesta != 's/i' ? '50px' : '50px', 
                                                            paddingRight: cellData.respuesta != 's/i' ? '30px' : '50px',
                                                            lineHeight: '1.2', // Ensure text doesn't take up excessive vertical space
                                                        }}
                                                    >
                                                        {cellData.respuesta}
                                                    </Typography>
                                                </Box>
                                            </Cell>
                                        </Tooltip>
                                    :  <Cell style={{padding: '0px', maxWidth:'130px', minWidth:'130px', 
                                                        height:'80px', borderBottom: "2px solid #d4d4d4", 
                                                        borderRight: "2px solid #e4dede", backgroundColor: '#e9e9e9', 
                                                        borderTop: cell.step != ''  && key != 0 ? "2px solid #818181" : null}}>
                                            <Typography style={{height:"25px", paddingLeft:"40%", paddingTop: "5px"}}>
                                                    {cell.icon}
                                            </Typography>
                                                
                                            <Typography style={{fontWeight:'bold', height:"10px", paddingLeft:cellData.respuesta != 's/i' ? '40px' : '50px', paddingTop:'5px'}}>
                                                {cellData.respuesta}
                                            </Typography>
                                            
                                        </Cell>
                                ))}
                            </Row>
                        ))}
                    </>      
            
        } else {
            return <div>      
                    <Typography
                        variant="h5">
                        <CircularProgress
                            variant="indeterminate"      
                            size={24}
                            thickness={4}                            
                        />
                        {t('text.loading')}
                    </Typography>        
                </div>     
        }
    }
}
export default compose(withTranslation())(ObjectiveCell);